import { lazy, Suspense } from 'react';

// The admin area guards itself: the shell renders null until permissions resolve
// and redirects a role with no admin sections (src/pages/Admin/index.tsx). It is
// not wrapped in RequirePermission because that guards a single key, and the area
// admits any role holding any one of its section keys, each section gated
// independently inside the shell.
const AdminArea = lazy(() => import('../pages/Admin'));

export const AdminRoutes = [
  {
    path: 'admin',
    element: (
      <Suspense fallback={<></>}>
        <AdminArea />
      </Suspense>
    ),
  },
];
